<template>
  <a-form
    id="my_form_styl"
    :label-col="{
      span: 12,
    }"
    :wrapper-col="{
      span: 12,
    }"
    v-if="true"
    :form="form"
  >
    <a-form-item :label="$t('Status')">
      <a-tag
        style="font-weight: bold"
        color="#E88666"
        v-if="document.status == 'OPISANY'"
        >{{ $t(document.status) }}</a-tag
      >
      <a-tag style="font-weight: bold" color="#EA5F40" v-else>{{
        $t("ZARCHIWIZOWANY")
      }}</a-tag>
    </a-form-item>

    <a-form-item :label="$t('File name')">
      <a-tooltip>
        <template slot="title">
          <span>{{ document.NAME }}</span>
        </template>
        <span>{{ document.NAME }}</span>
      </a-tooltip>
    </a-form-item>

    <a-form-item :label="$t('Date of receiving')">
      <span>{{ document.date_send }}</span>
    </a-form-item>

    <a-form-item :label="$t('Document type')">
      <span> {{ $t(document.document_type) }}</span>
    </a-form-item>

    <a-form-item :label="$t('Document name')">
      <span>{{ document.title }}</span>
    </a-form-item>

    <a-form-item :label="$t('Date of issue')">
      <span>{{ document.date_recept }}</span>
    </a-form-item>

    <a-form-item :label="$t('Document number')">
      <span>{{ document.num_doc }}</span>
    </a-form-item>

    <a-form-item :label="$t('main_company_n_hub')">
      <span>{{ my_company }}</span>
    </a-form-item>

    <a-form-item :label="$t('Owner')">
      <span>{{ kontragent }}</span>
    </a-form-item>

    <a-form-item :label="$t('Contractor')">
      <span>{{ company }}</span>
    </a-form-item>

    <a-form-item :label="$t('Specialization')">
      <span>
        <a-tag color="red" v-for="i of specializationValue" :key="i">{{
          i
        }}</a-tag>
      </span>
    </a-form-item>

    <a-form-item :label="$t('Tag')">
      <span>
        <a-tag color="blue" v-for="i of other_tags" :key="i">{{
          i.tagData
        }}</a-tag>
        <a-tag color="blue" v-for="i of user_tags" :key="i">{{
          i.tagData
        }}</a-tag>
      </span>
    </a-form-item>

    <a-form-item :label="$t('Keywords')">
      <span>
        <a-tag
          color="green"
          v-for="(item, key) of document.key_words"
          :key="key"
          >{{ item }}</a-tag
        >
      </span>
    </a-form-item>

    <a-form-item :label="$t('Original')">
      <span>{{ document.arch_doc_type }}</span>
    </a-form-item>

    <a-form-item
      v-if="document.arch_doc_type == 'Paper'"
      :label="$t('Folder number')"
    >
      <span v-if="document.status == 'ZARCHIWIZOWANY'">{{
        document.arch_doc_number
      }}</span>
      <span v-else>
        <a-input
          v-if="document.status == 'OPISANY'"
          :disabled="!currentEdit"
          v-decorator="[
            'arch_doc_number',
            {
              rules: [
                {
                  required: true,
                  message: $t('Folder number') + $t('required_field'),
                },
              ],
              initialValue: document.arch_doc_number,
            },
          ]"
        />
      </span>
    </a-form-item>
  </a-form>
</template>
<script>
import moment from "moment";
import { requestStep } from "@/requestFunc";

export default {
  props: [
    "document",
    "info",
    "key_words",
    "specialization",
    "responsible",
    "profile",
    "commentsData",
    "currentEdit",
  ],
  data() {
    return {
      flagMyCompany: true,
      flagReceiving: true,
      flagComment: true,
      flagDoctype: true,
      flagKontr: true,
      flagAcrhType: true,
      flagDaterec: true,
      flagNumdoc: true,
      flagAcrhNum: true,
      flagMpk: true,
      flagDocName: true,
      flagKeywords: true,
      flagTag: true,
      flagSpec: true,

      selectPaperType: this.document.arch_doc_type == "Paper" ? true : false,

      teczkalist: [],

      user_tags: [],
      other_tags: [],

      form: this.$form.createForm(this, { name: "third_set" }),
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
    };
  },
  computed: {
    specializationValue() {
      let spec = this.document.SPECJALIZACJA;
      if (spec) {
        try {
          spec = JSON.parse(spec);
          if (typeof spec == "string") throw Error;
        } catch {
          spec = [spec];
        }
        return spec;
      }
      return [];
    },
    // геттер вычисляемого значения
    my_company: function () {
      let comp = this.document.arrayCompany.find(
        (x) => x.ID == this.document.my_company
      );
      return comp.TITLE;
    },
    company: function () {
      let comp = this.document.arrayCompany.find(
        (x) => x.ID == this.document.kontragent
      );
      return comp["TITLE"];
    },
    variblMPK: function () {
      let comp = this.document.arrayCompany.find(
        (x) => x.ID == this.document.my_company
      );
      return comp.UF_CRM_MPK_LIST;
    },
    companyAssis: function () {
      let comp = this.document.arrayCompany.find(
        (x) => x.ID == this.document.kontragent
      );
      let user = this.info.data_user.find(
        (x) => x.ID == comp["ASSIGNED_BY_ID"]
      );
      return user.NAME + " " + user.LAST_NAME;
    },
    kontragent: function () {
      let comp = this.document.arrayCompany.find(
        (x) => x.ID == this.document.my_company
      );
      let user = this.document.userList.find(
        (x) => x.ID == comp["ASSIGNED_BY_ID"]
      );
      return user.NAME + " " + user.LAST_NAME;
    },
    Teczka() {
      let tags = JSON.parse(this.document.Teczka);
      let str = "";
      for (let i of tags) {
        str += i.tagData + ", ";
      }
      return str;
    },
    TeczkaUser: function () {
      let mas = [];
      for (let i of this.user_tags) {
        mas.push(i.tagData);
      }
      return mas;
    },
  },
  methods: {
    moment,
    submit(comments) {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.changeSpinning();
          requestStep(this.saveValues(values, comments))
            .done((data) => {
              var res = JSON.parse(data);
              if (
                this.document.status == "OPISANY" &&
                res.status == "ZARCHIWIZOWANY"
              ) {
                this.onback(this.document.ID);
              } else {
                this.document.status = res.status;
                if (values.title) this.document.title = values.title;
                this.onback();
              }
              this.$message.success(this.$t("Document archiving is done!"));
            })
            .fail((e) => {
              console.err(e);
              this.$message.error(this.$t("Error describing document"));
            })
            .always(() => {
              this.changeSpinning();
            });
        }
      });
    },
    saveValues(values, comments) {
      if (values.date_recept != undefined) {
        values.date_recept =
          values.date_recept != ""
            ? moment(values.date_recept).format("YYYY-MM-DD")
            : "";
      }

      if (values.date_send != undefined) {
        values.date_send =
          values.date_send != ""
            ? moment(values.date_send).format("YYYY-MM-DD")
            : "";
      }

      let data = {
        run: "archivation",
        title: this.document.title,
        arch_doc_type: this.document.arch_doc_type,
        arch_doc_number: values.arch_doc_number,
        name: this.document.NAME,
        comments: comments,
        creator: this.responsible,
        id_elem: this.document.mainid,
      };
      if (values.my_company != undefined) {
        data.my_company = values.my_company;
      }
      if (values.kontragent != undefined) {
        data.kontragent = values.kontragent;
      }
      for (let key in values) {
        if (values[key] != this.document[key]) {
          data[key] = {
            old: this.document[key],
            new: values[key],
          };
          this.document[key] = values[key];
        }
      }
      if (values.tags != undefined) {
        let def_tags = JSON.stringify(this.document.key_words);
        let set_tags = JSON.stringify(values.tags);
        this.document.key_words = set_tags;
        data.key_words =
          def_tags != set_tags
            ? { old: this.document.key_words, new: values.tags }
            : this.document.key_words;
      }
      if (values.mpk != undefined) this.document.mpk = values.mpk;
      if (values.Teczka != undefined) {
        var kk = [];
        for (var i of values.Teczka) {
          kk.push({ id: this.profile["ID"], tagData: i });
        }
        data["Teczka"] = JSON.stringify(this.other_tags.concat(kk));
        this.document.Teczka = data.Teczka;
      }
      return data;
    },
    handlerChange(value) {
      if (value == "Electronic") {
        this.selectPaperType = false;
      } else {
        this.selectPaperType = true;
      }
    },
    onback(idFile) {
      this.$emit("onback", {
        remove_elem: idFile,
      });
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
  },
  mounted() {
    this.other_tags = [];
    this.user_tags = [];
    var listtags = this.info.teczkalist;
    for (let item of this.document.Teczka) {
      if (item.id != this.profile["ID"]) {
        this.other_tags.push(item);
        let index = listtags.findIndex((x) => x.tagData == item.tagData);
        if (index != -1) {
          listtags.splice(index, 1);
        }
      } else {
        this.user_tags.push(item);
      }
    }
    this.teczkalist = listtags;

    BX24.fitWindow();
  },
};
</script>

<style scoped>
</style>